import { NO_MATCH, NEGATIVE_MATCH, POSITIVE_MATCH, DEFAULT_MATCH } from "./types";

import type { NodeModel } from "@/models/nodes/types";
import type { NodeCondition } from "@corca/data";

function checkOperatorType(nodeCondition: NodeCondition, node: NodeModel): number {
  if (!nodeCondition.hasType) {
    return NO_MATCH;
  }

  if (node.type === "operator") {
    if (nodeCondition.hasType?.includes(`not:${node.type}:${node.operatorType}`)) {
      return NEGATIVE_MATCH;
    }
    if (nodeCondition.hasType?.includes(`${node.type}:${node.operatorType}`)) {
      return POSITIVE_MATCH;
    }
  }

  return NO_MATCH;
}

export function checkType(nodeCondition: NodeCondition, node: NodeModel): number {
  if (!nodeCondition.hasType) {
    return NO_MATCH;
  }

  if (nodeCondition.hasType?.includes(`not:${node.type}`)) {
    return NEGATIVE_MATCH;
  }

  if (nodeCondition.hasType?.includes(node.type)) {
    return POSITIVE_MATCH;
  }

  const operatorTypeCheck = checkOperatorType(nodeCondition, node);

  if (operatorTypeCheck === NEGATIVE_MATCH || operatorTypeCheck === POSITIVE_MATCH) {
    return operatorTypeCheck;
  }

  const hasOnlyNegativeConditions =
    nodeCondition.hasType.length > 0 && nodeCondition.hasType.every((t) => t.startsWith("not:"));
  if (hasOnlyNegativeConditions) {
    return DEFAULT_MATCH;
  }

  // type is a non-optional field, so if it doesn't match any condition, it's a negative match
  return NEGATIVE_MATCH;
}
